import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomizedHttpService } from '../../shared/service/base/customized-http.service';

@Injectable({
  providedIn: 'root'
})
export class QuoteEmailLandingService {
  constructor(private httpService: CustomizedHttpService) {}

  processLanding(): Observable<any> {
    return this.httpService.get<any>('emaillanding/processquotelanding');
  }

  getGeneratedSignature() {
    return this.httpService.get<string>('emaillanding/generateclientsignature');
  }
}
